import React, { useEffect } from 'react';
import {
    changeColorAll,
    changeDepartment1All,
    changeDepartment2All,
    changeAddressAll,
    changeAddress2All,
    changeSuiteRoomAll,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP11T23 = React.memo((props) => {
    useEffect(() => {
        changeColorAll(props.color);
    }, [props.color]);

    useEffect(() => {
        changeDepartment1All(props.department1);
    }, [props.department1]);

    useEffect(() => {
        changeDepartment2All(props.department2);
    }, [props.department2]);

    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeAddress2All(props.address2);
    }, [props.address2]);

    useEffect(() => {
        changeSuiteRoomAll(props.suiteRoom);
    }, [props.suiteRoom]);

    return (
        <form action="" className="envelopes-fields">
            <hr />
            <div className="subtitle">Optional Line 1:</div>
            <TextField
                limit="55"
                showCount
                label="Office, Center, Department, Institute, Program"
                value={props.department1}
                setFunction={props.setDepartment1}
                placeholder="Example: Institute for Stroke and Cerebrovascular Diseases"
            />
            <hr />
            <div className="subtitle">Optional Line 2:</div>
            <TextField
                limit="55"
                showCount
                label="Office, Center, Department, Institute, Program"
                value={props.department2}
                setFunction={props.setDepartment2}
                placeholder="Optional second line"
            />
            <hr />
            <TextField
                required
                label="Address"
                value={props.suiteRoom}
                setFunction={props.setSuiteRoom}
                placeholder="Example: 6431 Fannin Street, Suite 1880"
            />
            <TextField
                required
                label="City, State, Zip"
                value={props.address2}
                setFunction={props.setAddress2}
                placeholder="Example: Houston, Texas 77030"
            />
            <hr />
            <SelectField
                required
                label="Window Envelope"
                value={props.window}
                setFunction={props.setWindow}
                options={[
                    { value: 1, label: 'Yes' },
                    { value: 0, label: 'No' },
                ]}
            />
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> UTHealth Houston | School of Public Health #10 Envelopes</div>
                <div className="description-list">
                    <span className="label">Description:</span>
                    <ul>
                        <li>Flat: #10 Business envelope</li>
                        <li>Stock: 100# Opaque White Cover</li>
                        <li>Printed: One Side</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP11T23;
